/*
 * Location groups for conversation examples.
 * Each group provides plausible driving locations for a given country.
 * On load, we detect the browser's country and randomly pick a group.
 *
 * Fields:
 *   home    — local city (daily driving hub)
 *   dest1   — weekend destination 1
 *   dest2   — weekend destination 2
 *   region  — shared destination for both cars ("likely a second home")
 *   happy   — "happy place" town name
 *   cars    — [car1, car2] vehicle model names
 *   season  — peak travel months (defaults to "June–August")
 */

var LOCATIONS = {
  US: [
    { home: 'Brooklyn', dest1: 'Kent, CT', dest2: 'the Berkshires', region: 'the Hudson Valley', happy: 'Rhinebeck, NY', cars: ['Cybertruck', 'Model Y'] },
    { home: 'San Francisco', dest1: 'Napa Valley', dest2: 'Lake Tahoe', region: 'Sonoma County', happy: 'Mendocino', cars: ['Model S', 'Model 3'] },
    { home: 'Los Angeles', dest1: 'Palm Springs', dest2: 'Santa Barbara', region: 'Joshua Tree', happy: 'Ojai', cars: ['Model X', 'Model 3'] },
    { home: 'Austin', dest1: 'Fredericksburg', dest2: 'Marfa', region: 'the Hill Country', happy: 'Wimberley', cars: ['Cybertruck', 'Model Y'] },
    { home: 'Boston', dest1: 'Cape Cod', dest2: 'the Berkshires', region: 'coastal Maine', happy: 'Provincetown', cars: ['Model 3', 'Model Y'] },
    { home: 'Chicago', dest1: 'Saugatuck, MI', dest2: 'Door County', region: 'southwest Michigan', happy: 'Galena, IL', cars: ['Model Y', 'Model 3'] },
    { home: 'Seattle', dest1: 'Leavenworth', dest2: 'the San Juan Islands', region: 'the Olympic Peninsula', happy: 'Whidbey Island', cars: ['Model X', 'Model 3'] },
    { home: 'Denver', dest1: 'Breckenridge', dest2: 'Steamboat Springs', region: 'the Front Range', happy: 'Crested Butte', cars: ['Model Y', 'Model 3'] },
    { home: 'Miami', dest1: 'Key West', dest2: 'Naples', region: 'Palm Beach', happy: 'Islamorada', cars: ['Model S', 'Model Y'] },
    { home: 'Portland', dest1: 'Hood River', dest2: 'Cannon Beach', region: 'the Willamette Valley', happy: 'Bend, OR', cars: ['Model 3', 'Model Y'] },
  ],
  GB: [
    { home: 'London', dest1: 'the Cotswolds', dest2: 'Brighton', region: 'Bath', happy: 'Rye', cars: ['Model 3', 'Model Y'] },
    { home: 'Manchester', dest1: 'the Lake District', dest2: 'the Peak District', region: 'North Yorkshire', happy: 'Ambleside', cars: ['Model Y', 'Model 3'] },
    { home: 'Edinburgh', dest1: 'the Highlands', dest2: 'St Andrews', region: 'Perthshire', happy: 'Pitlochry', cars: ['Model 3', 'Model Y'] },
    { home: 'Bristol', dest1: 'the Brecon Beacons', dest2: 'Devon', region: 'Cornwall', happy: 'Dartmouth', cars: ['Model Y', 'Model 3'] },
    { home: 'Birmingham', dest1: 'the Cotswolds', dest2: 'Snowdonia', region: 'the Welsh Borders', happy: 'Ludlow', cars: ['Model 3', 'Model Y'] },
  ],
  CA: [
    { home: 'Toronto', dest1: 'Prince Edward County', dest2: 'Muskoka', region: 'Niagara-on-the-Lake', happy: 'Collingwood', cars: ['Model Y', 'Cybertruck'] },
    { home: 'Vancouver', dest1: 'Whistler', dest2: 'the Okanagan', region: 'Tofino', happy: 'Salt Spring Island', cars: ['Model 3', 'Model Y'] },
    { home: 'Montreal', dest1: 'Mont-Tremblant', dest2: 'the Eastern Townships', region: 'Charlevoix', happy: 'Baie-Saint-Paul', cars: ['Model 3', 'Model Y'] },
    { home: 'Calgary', dest1: 'Banff', dest2: 'Canmore', region: 'the Rockies', happy: 'Invermere', cars: ['Model Y', 'Cybertruck'] },
    { home: 'Ottawa', dest1: 'the Gatineau Hills', dest2: 'Kingston', region: 'the Thousand Islands', happy: 'Wakefield', cars: ['Model 3', 'Model Y'] },
  ],
  FR: [
    { home: 'Paris', dest1: 'Honfleur', dest2: 'the Loire Valley', region: 'Normandy', happy: 'Giverny', cars: ['Model 3', 'Model Y'] },
    { home: 'Lyon', dest1: 'Annecy', dest2: 'Beaujolais', region: 'the Rh\u00f4ne Valley', happy: 'Gordes', cars: ['Model Y', 'Model 3'] },
    { home: 'Marseille', dest1: 'Cassis', dest2: 'Aix-en-Provence', region: 'the Luberon', happy: 'Saint-R\u00e9my-de-Provence', cars: ['Model 3', 'Model Y'] },
    { home: 'Bordeaux', dest1: 'Arcachon', dest2: 'the Dordogne', region: 'Saint-\u00c9milion', happy: 'Biarritz', cars: ['Model Y', 'Model 3'] },
  ],
  IT: [
    { home: 'Milan', dest1: 'Lake Como', dest2: 'the Langhe', region: 'Cinque Terre', happy: 'Bellagio', cars: ['Model 3', 'Model Y'] },
    { home: 'Rome', dest1: 'Orvieto', dest2: 'Tivoli', region: 'the Amalfi Coast', happy: 'Sperlonga', cars: ['Model Y', 'Model 3'] },
    { home: 'Florence', dest1: 'Chianti', dest2: 'Siena', region: 'the Tuscan coast', happy: 'San Gimignano', cars: ['Model 3', 'Model Y'] },
    { home: 'Turin', dest1: 'the Langhe', dest2: 'Aosta Valley', region: 'Monferrato', happy: 'Barolo', cars: ['Model Y', 'Model 3'] },
  ],
  AU: [
    { home: 'Sydney', dest1: 'the Blue Mountains', dest2: 'the Hunter Valley', region: 'the South Coast', happy: 'Byron Bay', cars: ['Model 3', 'Model Y'], season: 'December\u2013February' },
    { home: 'Melbourne', dest1: 'the Great Ocean Road', dest2: 'the Yarra Valley', region: 'the Mornington Peninsula', happy: 'Daylesford', cars: ['Model Y', 'Model 3'], season: 'December\u2013February' },
    { home: 'Brisbane', dest1: 'Noosa', dest2: 'the Gold Coast', region: 'the Sunshine Coast', happy: 'Byron Bay', cars: ['Model 3', 'Model Y'], season: 'December\u2013February' },
  ],
  DE: [
    { home: 'Berlin', dest1: 'Potsdam', dest2: 'the Spreewald', region: 'the Baltic coast', happy: 'R\u00fcgen', cars: ['Model 3', 'Model Y'] },
    { home: 'Munich', dest1: 'Garmisch-Partenkirchen', dest2: 'Salzburg', region: 'the Bavarian Alps', happy: 'Tegernsee', cars: ['Model Y', 'Model 3'] },
    { home: 'Hamburg', dest1: 'Sylt', dest2: 'L\u00fcbeck', region: 'the North Sea coast', happy: 'F\u00f6hr', cars: ['Model 3', 'Model Y'] },
  ],
  NL: [
    { home: 'Amsterdam', dest1: 'Haarlem', dest2: 'Texel', region: 'Zeeland', happy: 'Giethoorn', cars: ['Model 3', 'Model Y'] },
    { home: 'Rotterdam', dest1: 'Kinderdijk', dest2: 'Zeeland', region: 'Brabant', happy: 'Domburg', cars: ['Model Y', 'Model 3'] },
  ],
  HK: [
    { home: 'Hong Kong', dest1: 'Sai Kung', dest2: 'Tai Po', region: 'the New Territories', happy: 'Lantau', cars: ['Model 3', 'Model Y'] },
    { home: 'Hong Kong', dest1: 'Clear Water Bay', dest2: 'Shek O', region: 'the South Side', happy: 'Sai Kung', cars: ['Model Y', 'Model 3'] },
  ],
  ES: [
    { home: 'Madrid', dest1: 'Toledo', dest2: 'Segovia', region: 'the Sierra de Guadarrama', happy: 'Chinch\u00f3n', cars: ['Model 3', 'Model Y'] },
    { home: 'Barcelona', dest1: 'Costa Brava', dest2: 'Montserrat', region: 'the Empord\u00e0', happy: 'Cadaqu\u00e9s', cars: ['Model Y', 'Model 3'] },
  ],
  CN: [
    { home: 'Shanghai', dest1: 'Hangzhou', dest2: 'Suzhou', region: 'Moganshan', happy: 'Wuzhen', cars: ['Model 3', 'Model Y'] },
    { home: 'Beijing', dest1: 'Chengde', dest2: 'Tianjin', region: 'the Great Wall countryside', happy: 'Gubei Water Town', cars: ['Model Y', 'Model 3'] },
  ],
  IL: [
    { home: 'Tel Aviv', dest1: 'the Dead Sea', dest2: 'Haifa', region: 'the Galilee', happy: 'Rosh Pina', cars: ['Model 3', 'Model Y'] },
    { home: 'Tel Aviv', dest1: 'Caesarea', dest2: 'the Negev', region: 'Ein Gedi', happy: 'Zichron Ya\u2019akov', cars: ['Model Y', 'Model 3'] },
  ],
  DK: [
    { home: 'Copenhagen', dest1: 'Roskilde', dest2: 'Malm\u00f6', region: 'North Zealand', happy: 'Drag\u00f8r', cars: ['Model 3', 'Model Y'] },
    { home: 'Aarhus', dest1: 'Silkeborg', dest2: 'Ebeltoft', region: 'Djursland', happy: 'Skagen', cars: ['Model Y', 'Model 3'] },
  ],
  TW: [
    { home: 'Taipei', dest1: 'Jiufen', dest2: 'Yilan', region: 'the North Coast', happy: 'Hualien', cars: ['Model 3', 'Model Y'] },
    { home: 'Taichung', dest1: 'Sun Moon Lake', dest2: 'Lukang', region: 'Alishan', happy: 'Qingjing Farm', cars: ['Model Y', 'Model 3'] },
  ],
  NO: [
    { home: 'Oslo', dest1: 'Drammen', dest2: 'Lillehammer', region: 'the Oslofjord', happy: 'Hvaler', cars: ['Model 3', 'Model Y'] },
    { home: 'Bergen', dest1: 'Hardangerfjord', dest2: 'Voss', region: 'the fjords', happy: 'Rosendal', cars: ['Model Y', 'Model 3'] },
  ],
  CH: [
    { home: 'Zurich', dest1: 'Lucerne', dest2: 'Appenzell', region: 'the Engadin', happy: 'Grindelwald', cars: ['Model 3', 'Model Y'] },
    { home: 'Geneva', dest1: 'Lausanne', dest2: 'Chamonix', region: 'Montreux', happy: 'Gruy\u00e8res', cars: ['Model Y', 'Model 3'] },
  ],
  BE: [
    { home: 'Brussels', dest1: 'Bruges', dest2: 'the Ardennes', region: 'Ghent', happy: 'Dinant', cars: ['Model 3', 'Model Y'] },
    { home: 'Antwerp', dest1: 'Mechelen', dest2: 'Leuven', region: 'the Kempen', happy: 'Knokke', cars: ['Model Y', 'Model 3'] },
  ],
  FI: [
    { home: 'Helsinki', dest1: 'Turku', dest2: 'Porvoo', region: 'the Lakeland', happy: 'Naantali', cars: ['Model 3', 'Model Y'] },
  ],
  SE: [
    { home: 'Stockholm', dest1: 'Uppsala', dest2: 'Gotland', region: 'the archipelago', happy: 'Visby', cars: ['Model 3', 'Model Y'] },
  ],
  PT: [
    { home: 'Lisbon', dest1: 'Sintra', dest2: 'the Alentejo', region: 'Cascais', happy: 'Comporta', cars: ['Model 3', 'Model Y'] },
  ],
};

var DEFAULT_COUNTRY = 'US';

function detectCountry() {
  try {
    var languages = navigator.languages || [navigator.language || ''];
    for (var i = 0; i < languages.length; i++) {
      var parts = languages[i].split('-');
      if (parts.length >= 2) {
        var code = parts[parts.length - 1].toUpperCase();
        if (LOCATIONS[code]) return code;
      }
    }
  } catch (e) { /* SSR or restricted env */ }
  return DEFAULT_COUNTRY;
}

function pickLocationGroup() {
  var country = detectCountry();
  var groups = LOCATIONS[country] || LOCATIONS[DEFAULT_COUNTRY];
  return groups[Math.floor(Math.random() * groups.length)];
}

function buildLocationExamples(loc) {
  var localCount = Math.floor(Math.random() * 11) + 30; // 30–40
  var tripCount = Math.floor(Math.random() * 11) + 15;  // 15–25
  var season = loc.season || 'June\u2013August';

  return [
    {
      query: "What patterns do you see in my driving?",
      tool: "get_drives",
      segments: [
        "Looking at your last few months, your " + loc.cars[0] + " is primarily used for ",
        ["highlight", "weekend and rural driving"],
        " \u2014 frequent loops to " + loc.dest1 + " and " + loc.dest2 + " with occasional city runs. Your " + loc.cars[1] + " is the opposite: ",
        ["highlight", localCount + " of 50 recent trips are local"],
        ", almost entirely within " + loc.home + ". " + loc.region + " is a common destination for both, likely a second home.",
      ],
    },
    {
      query: "Where\u2019s my happy place?",
      tool: "get_drives",
      segments: [
        "Based on your trips, I\u2019d say it\u2019s ",
        ["highlight", loc.happy],
        ". You\u2019ve driven there ",
        ["data", tripCount + " times since last spring"],
        ", mostly on weekends and almost always staying 2+ days. You go most often in " + season + ", arriving Friday evening and leaving Sunday afternoon. It\u2019s your getaway spot.",
      ],
    },
  ];
}

module.exports = {
  pickLocationGroup: pickLocationGroup,
  buildLocationExamples: buildLocationExamples,
};
